<div class="row">
  <div class="col-sm-8">
    <app-card
      [title]="'admin.service.request.view.info_title'|translate"
      [advanceButton]="true"
      [advancedButtons]="[moreButton]"
      (outputButtonAdvance)="calFunction($event)"
    >
      <table *ngIf="request.orderItemProducts?.length" class="mx-2">
        <tr>
          <td width="150">{{'doctrine.attributes.collection' | translate}}</td>
          <td>{{ request.orderItemProducts[0].orderItem?.collection?.name }}</td>
        </tr>
        <tr>
          <td>{{'doctrine.attributes.model' | translate}}</td>
          <td>{{ request.orderItemProducts[0].orderItem?.model?.name }}</td>
        </tr>
      </table>
      <div [@openClose]="showMore" class="overflow-hidden">
        <div *ngFor="let productItem of request.orderItemProducts;let j=index;" class="m-t-15">
          <p class="m-b-5 px-2">{{'admin.order.element' | translate}} {{j + 1}}</p>
          <div class="element-card px-2">
            <table>
              <tr>
                <td width="150">{{'doctrine.attributes.product' | translate}}</td>
                <td>{{$any(productItem.product)?.name}}</td>
              </tr>
              <tr *ngIf="!isRugProduct(productItem)">
                <td>{{'doctrine.attributes.fabric' | translate}}</td>
                <td>
                  <ng-container *ngFor="let fabric of productItem.orderItemProductFabricCollections; let last = last">
                    {{fabric | FabricFormat}}{{last ? '' : ' | '}}
                  </ng-container>
                </td>
              </tr>
              <ng-container *ngIf="isRugProduct(productItem)">
                <tr *ngIf="carpetSizeLabel(productItem.widthCm, productItem.lengthCm) as sizeLabel">
                  <td>{{'admin.dealer.order.carpet_size' | translate}}</td>
                  <td>{{sizeLabel}}</td>
                </tr>
                <!-- INERT on this screen until the API serializes the options. The
                     service-request show() group list gives OrderItemOptions no serialized
                     attribute, so every row arrives as {} and no name resolves. Needs
                     `service-request-view` on OrderItemOptions::$urbanOption AND on
                     Option::$name / $carpetRole / $parent — API side, out of scope here.
                     The Carpet size row above does render, because widthCm/lengthCm are in
                     the group. Keep these three: they are correct against the payload
                     shape the order screens already return, and light up for free once
                     the groups are added. -->
                <tr *ngIf="rugOptionName(productItem, CARPET_ROLE_SHAPE) as shapeName">
                  <td>{{carpetRoleLabelKey(CARPET_ROLE_SHAPE) | translate}}</td>
                  <td>{{shapeName}}</td>
                </tr>
                <tr *ngIf="rugOptionName(productItem, CARPET_ROLE_FINISHING) as finishingName">
                  <td>{{carpetRoleLabelKey(CARPET_ROLE_FINISHING) | translate}}</td>
                  <td>{{finishingName}}</td>
                </tr>
                <tr *ngIf="rugOptionName(productItem, CARPET_ROLE_COLOUR) as colourName">
                  <td>{{carpetRoleLabelKey(CARPET_ROLE_COLOUR) | translate}}</td>
                  <td>{{colourName}}</td>
                </tr>
              </ng-container>
            </table>
          </div>
        </div>
        <p class="m-b-5 px-2 m-t-15">{{'doctrine.service_subject.description' | translate}}</p>
        <p class="px-2 ms-3">{{request.message}}</p>
        <table class="m-t-15 mx-2">
          <tr>
            <td width="150">{{'doctrine.service_request.subject' | translate}}</td>
            <td>
              <span>{{request.serviceSubject ? request.serviceSubject.name : request.subject }}</span>
              <span *ngIf="request.serviceSubjectItems?.length"> > </span>
              <span
                *ngFor="let Subject of request.serviceSubjectItems;let last = last; let index = index">{{Subject.name}} {{last ? '' : '>'}} </span>
            </td>
          </tr>
        </table>
        <table class="m-t-15 mx-2">
          <tr>
            <td width="150"></td>
            <td>
              <a
                *ngFor="let file of request.files"
                href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
                download="{{baseUrl + '/download?path=' + file.filename}}"
                class="btn btn-primary btn-file"
              >
                <span class="fa {{getFontAwesomeIconFromMIME(file.mimeType)}}"></span>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </app-card>
    <app-manage-request-reply></app-manage-request-reply>
  </div>
  <div class="col-sm-4">
    <app-card [title]="'admin.service.request.view.status_title'|translate">
      <div *ngIf="request.order">
        <div class="row pb-2">
          <div class="col-4 font-weight-bold">{{'doctrine.attributes.date'|translate}}</div>
          <div *ngIf="request.outOfWarranty" class="col-8 text-danger">
            {{request.createdAt|DateFormat}} ({{'doctrine.service_request.more_than_3_years' | translate}})
          </div>
          <div *ngIf="!request.outOfWarranty" class="col-8">
            {{request.createdAt|DateFormat}}
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-4 font-weight-bold">{{'doctrine.order.status'|translate}}</div>
          <div class="col-8">
            <span *ngIf="archiveId">
              {{'doctrine.service_request.status.closed'|translate}}
            </span>
            <span *ngIf="!archiveId && !editStatus">
              {{(request.status ? request.status.translationKey : '-')|translate}}
              <a (click)="changeEditStatus()" class="action-button ripple light">
                <i class="fa fa-pencil ps-1"></i>
              </a>
            </span>
            <span *ngIf="!archiveId && editStatus">
              <ng-select
                *ngIf="statuses"
                [items]="statuses"
                (change)="saveStatus($event)"
                class="w-100"
                [(ngModel)]="request.status"
                [clearable]="false">
                <ng-template ng-label-tmp let-item="item">
                  {{item.translationKey|translate}}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{item.translationKey|translate}}
                </ng-template>
              </ng-select>
            </span>
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-4 font-weight-bold">{{'doctrine.order.reference'|translate}}</div>
          <div class="col-8">{{request.order.reference}}</div>
        </div>
        <div class="row pb-2">
          <div class="col-4 font-weight-bold">{{'doctrine.attributes.dealer'|translate}}</div>
          <div class="col-8">{{request.order.user.companyName}}</div>
        </div>
        <div class="row pb-2">
          <div class="col-4 font-weight-bold">{{'doctrine.order.number'|translate}}</div>
          <div class="col-8"><a class="order-link" [routerLink]="['/back-office/order', request.order.id]" target="_blank">{{request.order.orderNo}}<i class="fa fa-link ms-1"></i></a></div>
        </div>
        <div class="row pb-2">
          <div class="col-4 font-weight-bold">{{'doctrine.service.service_number'|translate}}</div>
          <div class="col-8">{{request.serviceNumber}}</div>
        </div>
      </div>
    </app-card>
    <app-card *ngIf="request.reply" [title]="'doctrine.service_request.steps'|translate">
      <ul>
        <li class="timeline-item" *ngFor="let replyItem of request.reply.replyItems; let i=index; ">
          <ng-container *ngIf="!replyItem.skipped">
            <div *ngIf="i > 0" class="text-primary vertical-line"></div>
            <button type="button" [ngClass]="replyItem.isDone ? 'timeline-icon' : 'timeline-icon-outline'">
              <i [ngClass]="getReplyItemIconClass(replyItem.solutionStep.actionType.name)"></i>
            </button>
            <span class="ms-2 text-primary">{{replyItem.solutionStep.actionType.translationKey|translate}}</span>
          </ng-container>
        </li>
      </ul>
    </app-card>
  </div>
</div>
